<template>
      <vue-page-transition name="fade-in-down">
        <v-content class="bg-content">
    <div class="news-search">
          <section class="step-section">
    <v-container grid-list-xl  style="padding-block: 0px; margin-top: 30px;">
          <!-- <v-flex xs4 sm4 md4 lg12>
                  <ChatGPT />
                  <br />
          <br />
          <br />
          </v-flex> -->
          <div class="ai-header-wrapper">
  <div class="ai-background">
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" class="ai-brain-background">
      <circle v-for="n in 15" :key="'c' + n" :cx="Math.random()*100" :cy="Math.random()*100" r="0.5" />
      <line v-for="n in 30" :key="'l' + n" :x1="Math.random()*100" :y1="Math.random()*100" :x2="Math.random()*100" :y2="Math.random()*100" />
    </svg>
  </div>

  <v-row class="ai-header-content" justify="center">
    <v-col cols="12" class="text-center">
      <!-- <v-icon large color="cyan lighten-2" class="ai-icon pulse-glow">mdi-brain</v-icon> -->
      <h1 class="ai-title">Artist Profiles</h1>
      <p class="ai-subtitle">Create and manage artist profiles</p>
    </v-col>
  </v-row>
</div>

          <!-- <v-row>
            <v-col cols="12" class="text-center">
              <h1 style="color: white;">Artist Profiles</h1>
              <p style="color: white;">Create and manage artist profiles</p>
            </v-col>
          </v-row> -->
          <!-- <v-row>
                   <v-col cols="12">
                     <h3 style="color: green;">Music Artists</h3>
                     <p style="color: white; text-align: center;">Profile Gallery</p>
                     
                   </v-col>
                 </v-row> -->
       <v-layout fluid row wrap>
        
        <div v-if="artistProfiles.length" class="artist-profiles">
               <div
                 v-for="(profile, index) in artistProfiles"
                 :key="index"
                 class="profile-card2"
                 @click="toggleCardSize(index)"
                 :class="{ expanded: expandedIndex === index }"
               >
                 <div class="album-container">
                   <!-- Album Cover -->
                   <div class="album-cover">
                    <section v-if="artistData">

        <img :src="artistData.images[0]?.url" class="cover-image2" />
      </section>
                     <img :src="profile.image" class="cover-image2" />
                   </div>
                   <!-- Vinyl Record -->
                   <div
                     class="vinyl-record"
                     :class="{ 'slide-out': expandedIndex === index }"
                   >
                     <img
                       src="https://gallery.yopriceville.com/var/resizes/Free-Clipart-Pictures/Music-PNG/Gramophone_Vinyl_LP_Record_PNG_Transparent_Clip_Art_Image.png"
                       alt="Vinyl Record"
                       class="vinyl-image"
                     />
                   </div>
                 </div>
                 <!-- Artist Information -->
                 <h3>{{ profile.artistName }}</h3>
          
                 <v-btn small color="blue" @click.stop="viewArtistProfile(index)">View Profile</v-btn>
                 <v-btn small @click.stop="editArtistProfile(index)">Edit</v-btn>

                 <v-btn small color="red" @click.stop="deleteArtistProfile(index)">Delete</v-btn>
               </div>
             </div>
        

         <div>
           <!-- Artist Profiles -->


           
             <br>
          

    <!-- Loading Animation -->
    <div v-if="loading" class="loading-overlay">
      <div class="spinner"></div>
      <h3> Searching... {{ artistName }}</h3>
    </div>

    <!-- Error and Notifications as Popups -->
    <transition name="fade">
      <div v-if="error" class="popup-card error-popup">
        <p>{{ error }}</p>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="notification" class="popup-card notification-popup">
        <p>{{ notification }}</p>
      </div>
    </transition>
    <!-- Loading Indicator -->
    <div v-if="loading" class="loading-overlay">
      <div class="spinner"></div>
      <h3>{{ loadingText }}</h3>
    </div>
 
           <v-alert v-if="missingData.length" type="warning" dismissible>
             Please provide the following information to proceed:
             <ul>
               <li v-for="(field, index) in missingData" :key="index">{{ field }}</li>
             </ul>
           </v-alert>
 
           <v-divider dark />
     <br>
   </div>
 
       </v-layout>
     </v-container>
          </section>
     </div>
        </v-content>
      </vue-page-transition>
 </template>
 
 <script>
import thinkingAudio from "../assets/audio/Wave.wav";
import codeCompleteAudio from "../assets/audio/input4.wav";
import confetti from "canvas-confetti";
import axios from "axios";

 export default {
   data() {
     return {
      isExpanded: false,
      showLegend: true,
      legendPosition: { x: 50, y: 50 },
      dragging: false,
      collectedDataPoints: 0,
      totalDataPoints: 36, // Adjust to match the number of data points
      dataStatus: [],
      currentArtistIndex: null,
    isPredicting: false,
    predictedTourDate: null,
    thermometerFill: 0,
    likelihoodCategory: 'Unlikely',
      artistProfileScore: 0,
      totalPossibleScore: 10, // You can adjust this based on the weight you assign each criterion
      ticketEventCount: 0,
      topTrackCount: 0,
      newsArticleCount: 0,
      artistQuery: "",
      topTracks: [],
      newReleases: [],
      albumTracks: [],
      shows: [],
      ticketmasterEvents: [],
      savedArtists: [],
       queryPrompt: "",
       artistName: "",
       artistLabelSignedTo: "",
       artistManager: "",
       artistEmail: "",
       artistPhone: "",
       artistLightingDesigner: "",
       artistLightingDesignerEmail: "",
       artistLightingDesignerPhone: "",
       artistProductionManager: "",
       artistProductionManagerEmail: "",
       artistProductionManagerPhone: "",
       artistTourManager: "",
       artistTourManagerEmail: "",
       artistTourManagerPhone: "",
       artistBusinessManager: "",
       artistBusinessManagerEmail: "",
       artistBusinessManagerPhone: "",
       artistVideoDesigner: "",
       artistVideoDesignerEmail: "",
       artistVideoDesignerPhone: "",
       artistFrontOfHouseEngineer: "",
       artistFrontOfHouseEngineerEmail: "",
       artistFrontOfHouseEngineerPhone: "",
       artistSetDesigner: "",
       artistSetDesignerEmail: "",
       artistSetDesignerPhone: "",
       artistWebsite: "",
       artistSocialMedia: "",
       artistBio: "",
       hottestTracks: "",
       monthlyListeners: "",
       fanEngagement: "",
       preferredVenues: "",
       pastEventDates: "",
       genre: "",
       artistCount: 1,    
       top100artistranking: "",
       loading: false,
       loadingText: "",
       isRecording: false,
       recordingStateColor: 'green', // Default color
       error: null,
       notification: "Loading Artist Profiles...",
       foundDataMessage: "",
       missingData: [],
       artistProfiles: JSON.parse(localStorage.getItem("artistProfiles")) || [],
       editingProfileIndex: -1,
       artistData: null,
       savedQueries: JSON.parse(localStorage.getItem("savedQueries")) || [],
       currentStep: 1, // Tracks progress (1 = Artist Profile, 2 = News, 3 = Prediction)
       expandedIndex: null, // Tracks which artist card is expanded
       progressSteps: ["Profile", "News", "Prediction"],       
       editingQueryIndex: -1,
       details: "",
       searchQuery: "", // Search term
       searchNews: "",
       fromDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split("T")[0], // Defaults to a week prior
       toDate: "", // Optional
       sortBy: "relevancy", // Default sort option
       selectedDomains: [], // Array to store selected domains
       domainOptions: [
 
       { value: "cnn.com", image: require("@/assets/news/cnn.png") },
       { value: "theverge.com", image: require("@/assets/news/verge.png") },
       { value: "bbc.com", image: require("@/assets/news/bbc.png") },
       { value: "techcrunch.com", image: require("@/assets/news/techcrunch.png") },
       { value: "bloomberg.com", image: require("@/assets/news/bloomberg.png") },
       { value: "buzzfeed.com", image: require("@/assets/news/buzzfeed.png") },
       { value: "ew.com", image: require("@/assets/news/entertainment.png") },
       { value: "google.com", image: require("@/assets/news/google.png") },
       { value: "mashable.com", image: require("@/assets/news/mashable.png") },
       { value: "billboard.com", image: require("@/assets/news/billboard.png") },
       { value: "axios.com", image: require("@/assets/news/axios.png") },
       ],
       articles: [],
     };
   },
   components: {

   },
   computed: {
     sortedSavedQueries() {
       return [...this.savedQueries].sort((a, b) => {
         const rankA = parseInt(a.top100artistranking) || Infinity;
         const rankB = parseInt(b.top100artistranking) || Infinity;
         return rankA - rankB;
       });
     },
     pendingDataPoints() {
      return this.totalDataPoints - this.collectedDataPoints;
    },
   },
   mounted() {
    // Trigger the prompt and start recording after the component is mounted
    setTimeout(() => {
      this.promptUserAndStartRecording();
    }, 10000); // 3 seconds after page load
  },
   methods: {
    readOutLoud(message) {
  if (!('speechSynthesis' in window)) {
    console.warn('Speech Synthesis API is not supported in this browser.');
    return;
  }

  const speech = new SpeechSynthesisUtterance(message);
  const voices = window.speechSynthesis.getVoices();

  // Select the preferred voice
  const preferredVoice = voices.find(voice => voice.name === "Google UK English Female");
  const fallbackVoice = voices.find(voice => voice.lang.includes('en-GB') && voice.gender === 'female');

  // Assign voice, pitch, rate, and volume
  speech.voice = preferredVoice || fallbackVoice || voices[0];
  speech.pitch = 1;
  speech.rate = 1;
  speech.volume = 1;

  // Speak the message
  window.speechSynthesis.speak(speech);

  // Optional: Display message in UI if applicable
  if (this.displayResponse) {
    this.displayResponse(message);
  }

},

    showNotification(message) {
  this.notification = message;
  setTimeout(() => {
    this.notification = null;
  }, 5000); // Auto-dismiss after 5 seconds
},
promptUserAndStartRecording() {
      // Use speech synthesis to ask the user what they want to create
      this.readOutLoud('Who do you want to research?');
      window.scrollTo({ top: 700, behavior: 'smooth' });
      // Wait for 2 seconds after the question, then start recording
      setTimeout(() => {
      this.isRecording = true;
      this.recordingStateColor = 'green'; // Color when recording starts
      this.startRecording();
    }, 2000);
    },
scrollToStep(step) {
  this.currentStep = step;
  const section = document.getElementById(`step-${step}`);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
},


    showError(message) {
      this.error = message;
      setTimeout(() => {
        this.error = null;
      }, 3000);
    },
    toggleLegend() {
      this.showLegend = !this.showLegend;
    },
    updateDataStatus() {
      const requiredFields = [
        { field: "artistName", label: "Artist Name" },
        { field: "monthlyListeners", label: "Monthly Listeners" },
        { field: "hottestTracks", label: "Hottest Tracks" },
        { field: "fanEngagement", label: "Fan Engagement" },
        { field: "artistLabelSignedTo", label: "Record Label" },
        { field: "artistManager", label: "Artist Manager" },
        { field: "artistEmail", label: "Artist Email" },
        { field: "artistPhone", label: "Artist Phone" },
        { field: "artistWebsite", label: "Artist Website" },
        { field: "details", label: "Details" },
      ];

      const currentArtist = this.artistProfiles[this.currentArtistIndex];
      this.dataStatus = requiredFields.map(({ field, label }) => ({
        label,
        collected: currentArtist[field] && currentArtist[field].trim() !== "",
      }));
      this.collectedDataPoints = this.dataStatus.filter((item) => item.collected)
        .length;
    },
    scheduleSearch(duration) {
      this.$nextTick(() => {
        alert(`AI search scheduled for ${duration}.`);
      });
    },
    startDrag() {
  this.dragging = true;
  document.addEventListener("mousemove", this.onDrag);
  document.addEventListener("mouseup", this.stopDrag);
},

    onDrag(event) {
      if (this.dragging) {
        this.legendPosition = {
          x: event.clientX,
          y: event.clientY,
        };
      }
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    viewArtistProfile(index) {
      this.currentArtistIndex = index;
      this.updateDataStatus();
    },
    async searchArtist() {
      const token = await this.getToken();        
      this.showNotification("Searching News, Spotify and Ticketmaster for artist data...");
      try {
        const response = await axios.get(`https://api.spotify.com/v1/search?q=${this.artistQuery}&type=artist`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const artist = response.data.artists.items[0];
        this.artistData = artist;
        await this.fetchArtistDetails(artist.id, token);
        this.currentStep = 2;
        this.notifyStepComplete("News");
            setTimeout(() => {
      const requiredFields = [
        { field: "artistName", label: "Artist Name" },
    { field: "monthlyListeners", label: "Monthly Listeners" },
    { field: "hottestTracks", label: "Hottest Tracks" },
    { field: "fanEngagement", label: "Fan Engagement" },
    { field: "artistLabelSignedTo", label:  "Record Label" },
    { field: "artistManager", label: "Artist Manager" },
    { field: "artistEmail", label: "Artist Email" },
    { field: "artistPhone", label: "Artist Phone" },
    { field: "artistWebsite", label: "Artist Website" },
    { field: "details", label: "Details" },
  ];
      this.missingData = requiredFields
    .filter(({ field }) => !this[field] || this[field].trim() === "")
    .map(({ label }) => label);
    this.collectedDataPoints = requiredFields.length - this.missingData.length;
    this.updateThermometer();
  
    if (this.missingData.length > 0) {
    this.showNotification(`Missing data: ${this.missingData.join(", ")}`);
    return;
    }
    this.showNotification("All data points collected successfully!");
    }, 3000);
      } catch (error) {
        console.error("Error searching for artist:", error);
        this.showError("Error searching for artist");
      }
    },
    async fetchArtistDetails(artistId, token) {
      await Promise.all([
        this.getTopTracks(artistId, token),
        this.getNewReleases(artistId, token),
        this.getShows(artistId, token),
        this.getTicketmasterEvents(),
        this.submitQuery(),
      ]);
    },
    async getTopTracks(artistId, token) {
      try {
        const response = await axios.get(`https://api.spotify.com/v1/artists/${artistId}/top-tracks?market=US`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.topTracks = response.data.tracks.map(track => ({
          ...track,
          listeners: Math.floor(Math.random() * 1000000), // Mock listeners data
        }));
      } catch (error) {
        console.error("Error fetching top tracks:", error);
      }
    },
    async getNewReleases(artistId, token) {
      try {
        const response = await axios.get(`https://api.spotify.com/v1/artists/${artistId}/albums?include_groups=album,single&market=US&limit=10`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.newReleases = response.data.items;
      } catch (error) {
        console.error("Error fetching new releases:", error);
      }
    },
    async getShows(artistId, token) {
      try {
        const response = await axios.get(`https://api.spotify.com/v1/shows?ids=5CfCWKI5pZ28U0uOzXkDHe,5as3aKmN2k11yfDDDSrvaZ`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.shows = response.data.shows;
      } catch (error) {
        console.error("Error fetching shows:", error);
      }
    },
    async getTicketmasterEvents() {
      try {
        const response = await axios.get(
          `https://app.ticketmaster.com/discovery/v2/events.json?keyword=${encodeURIComponent(
            this.artistData.name
          )}&countryCode=US&apikey=urzDHfIpUlR6bHW3gSuErLG9Vt3yEdKm`
        );
        const events = response.data._embedded?.events || [];
        this.ticketmasterEvents = events.map(event => ({
          id: event.id,
          name: event.name,
          date: event.dates.start.localDate,
          venue: event._embedded.venues[0].name,
          location: `${event._embedded.venues[0].city.name}, ${event._embedded.venues[0].country.name}`,
          url: event.url,
        }));
      } catch (error) {
        console.error("Error fetching Ticketmaster events:", error);
      }
    },
    async getAlbumTracks(albumId) {
      const token = await this.getToken();
      try {
        const response = await axios.get(`https://api.spotify.com/v1/albums/${albumId}/tracks`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.albumTracks = response.data.items;
      } catch (error) {
        console.error("Error fetching album tracks:", error);
      }
    },
    async getToken() {
      try {
        const response = await axios.post(
          "https://accounts.spotify.com/api/token",
          new URLSearchParams({
            grant_type: "client_credentials",
            client_id: "1522ec4d96914840aef42817fe1b387b",
            client_secret: "673c7686457a438488401835249dca6b",
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        return response.data.access_token;
      } catch (error) {
        console.error("Error fetching access token:", error);
      }
    },
    saveArtist() {
      if (!this.artistData) return;
      this.savedArtists.push(this.artistData);
      this.artistData = null;
      this.topTracks = [];
    },
    editArtist(artist) {
      this.artistQuery = artist.name;
      this.artistData = artist;
      this.savedArtists = this.savedArtists.filter((a) => a.id !== artist.id);
    },
    deleteArtist(artistId) {
      this.savedArtists = this.savedArtists.filter((artist) => artist.id !== artistId);
    },
     triggerConfetti() {
     confetti({
       particleCount: 2000,
       spread: 800,
       angle: 90,
       origin: { y: 0.6 },
     });
   },
   triggerConfetti2() {
     confetti({
       particleCount: 550,
       spread: 250,
       origin: { y: 0.6 },
     });
   },
   triggerConfetti3() {
     confetti({
       particleCount: 750,
       spread: 450,
       origin: { y: 0.6 },
     });
   },
   notifyStepComplete(stepName) {
    this.showNotification(`${stepName} completed successfully!`);

     this.triggerConfetti();
   },


   startRecording() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.start();

    recognition.onstart = () => {
      this.recordingStateColor = 'blue'; // Color when user is speaking
    };

    recognition.onresult = (event) => {
    
      this.queryPrompt = event.results[0][0].transcript;
      this.recordingStateColor = 'red'; // Color just before submitting
      setTimeout(() => {
        this.submitQuery();
        this.isRecording = false;
        this.recordingStateColor = 'blue'; // Reset color after submitting
      }, 1000);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event);
      this.isRecording = false;
    };

    this.isRecording = true;
  },


  stopRecording() {
    this.isRecording = false;
    this.recordingStateColor = 'blue'; // Reset color when stopped
    // Logic to stop recording. This depends on your implementation of SpeechRecognition.
    // If you've stored the instance of SpeechRecognition in a variable, call stop() on it.
  },


   async submitQuery() {
  this.currentStep = 1;
  this.isExpanded = true; // Expand the section when script runs
  // Step 1: Validation
  if (!this.queryPrompt) {
    this.showNotification("");
    this.readOutLoud("");
    this.scrollToStep(1); // Ensure user focuses on the query field
    return;
  }

  // Step 2: Show Loading State
  this.loading = true;
  this.loadingText = "Processing your query...";
  this.showNotification("Processing your query...");
  this.readOutLoud("Processing your query...");
  new Audio(thinkingAudio).play();

  // Step 3: Build Input Data
  const inputData = [
    `Artist Name: ${this.artistName}`,
    `Record Label: ${this.artistLabelSignedTo}`,
    `Artist Manager: ${this.artistManager}`,
    `Artist Email: ${this.artistEmail}`,
    `Artist Phone: ${this.artistPhone}`,
    `Artist Lighting Designer: ${this.artistLightingDesigner}`,
    `Artist Lighting Designer Email: ${this.artistLightingDesignerEmail}`,
    `Artist Lighting Designer Phone: ${this.artistLightingDesignerPhone}`,
    `Artist Production Manager: ${this.artistProductionManager}`,
    `Artist Production Manager Email: ${this.artistProductionManagerEmail}`,
    `Artist Production Manager Phone: ${this.artistProductionManagerPhone}`,
    `Artist Tour Manager: ${this.artistTourManager}`,
    `Artist Tour Manager Email: ${this.artistTourManagerEmail}`,
    `Artist Tour Manager Phone: ${this.artistTourManagerPhone}`,
    `Artist Business Manager: ${this.artistBusinessManager}`,
    `Artist Business Manager Email: ${this.artistBusinessManagerEmail}`,
    `Artist Business Manager Phone: ${this.artistBusinessManagerPhone}`,
    `Artist Video Designer: ${this.artistVideoDesigner}`,
    `Artist Video Designer Email: ${this.artistVideoDesignerEmail}`,
    `Artist Video Designer Phone: ${this.artistVideoDesignerPhone}`,
    `Artist Front Of House Engineer: ${this.artistFrontOfHouseEngineer}`,
    `Artist Front Of House Engineer Email: ${this.artistFrontOfHouseEngineerEmail}`,
    `Artist Front Of House Engineer Phone: ${this.artistFrontOfHouseEngineerPhone}`,
    `Artist Set Designer: ${this.artistSetDesigner}`,
    `Artist Set Designer Email: ${this.artistSetDesignerEmail}`,
    `Artist Set Designer Phone: ${this.artistSetDesignerPhone}`,
    `Artist Website: ${this.artistWebsite}`,
    `Artist Social Media: ${this.artistSocialMedia}`,
    `Artist Bio: ${this.artistBio}`,
    `Hottest Tracks: ${this.hottestTracks}`,
    `Monthly Listeners: ${this.monthlyListeners}`,
    `Fan Engagement: ${this.fanEngagement}`,
    `Preferred Venues: ${this.preferredVenues}`,
    `Past Event Dates: ${this.pastEventDates}`,
    `Genre: ${this.genre}`,
    `Top 100 Ranking: ${this.top100artistranking}`,
    `Details: ${this.details}`,
  ].join("\n");

  this.queryPrompt = `${this.queryPrompt}\n${inputData}`;

  // Step 4: API Call
  try {
    for (let i = 0; i < this.artistCount; i++) {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: this.queryPrompt }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const content = await response.json();
      this.processFoundData(content);
      this.showNotification("Artist profile created successfully!");
      this.readOutLoud("Artist profile created successfully!");
      this.calculateFillPercentage();
      
      this.triggerConfetti();
    }

    setTimeout(() => {
      this.showNotification("Adding data to artist profile...");
      this.readOutLoud("Adding data to artist profile...");
      this.editArtistProfile(this.artistProfiles.length - 1);   
      this.currentStep = 1;
      window.scrollTo({ top: 1200, behavior: 'smooth' });
    }, 5000);
    setTimeout(() => {
      const requiredFields = [
        { field: "artistName", label: "Artist Name" },
    { field: "monthlyListeners", label: "Monthly Listeners" },
    { field: "hottestTracks", label: "Hottest Tracks" },
  ];
      this.missingData = requiredFields
    .filter(({ field }) => !this[field] || this[field].trim() === "")
    .map(({ label }) => label);
    this.collectedDataPoints = requiredFields.length - this.missingData.length;
    this.updateThermometer();
  
    if (this.missingData.length > 0) {
    this.showNotification(`Missing data: ${this.missingData.join(", ")}`);
    this.scrollToStep(1);
    return;
    }
    this.showNotification("All data points collected successfully!");
    }, 6000);
    setTimeout(() => {
      window.scrollTo({ top: 200, behavior: 'smooth' });
    }, 8000);

    setTimeout(() => {
      this.showNotification("Triggering online sources search in news, spotify, and ticketmaster...");
      this.readOutLoud("Triggering online sources search in news, spotify, and ticketmaster...");
      this.triggerNewsSearch();
      setTimeout(() => {
      this.moveToNextStep();
    }, 5000);
    }, 10000);
  } catch (error) {
    console.error("Error during query submission:", error);
    this.loadingText = "Error creating artist profile. Please try again.";
    this.showError("Error creating artist profile. Please try again.");
    this.readOutLoud("Error creating artist profile. Please try again.");
  } finally {
    this.loading = false;
    document.getElementById('artist').scrollIntoView({ behavior: 'smooth' });
    new Audio(codeCompleteAudio).play();
  }
},
toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
calculateFillPercentage() {
  let score = 0;
  score += (this.artistName ? 1 : 0);
  score += (this.artistLabelSignedTo ? 1 : 0);
  this.fillPercentage = (score / this.totalPossibleScore) * 100;
  // Update thermometer visualization based on fillPercentage
},
     navigateToNews(index) {
   const query = this.savedQueries[index];
   if (query) {
     localStorage.setItem("currentQueryIndex", index); // Save the index temporarily
     this.$router.push({ name: "News" }); // Navigate to News.vue
   }
 },
     async startPrediction() {
       if (!this.isPredictionDataComplete()) {
         alert("Please fill out all necessary data to make a prediction.");
         return;
       }
 
       this.currentStep = 3;
       this.isPredicting = true;
            this.showNotification("Predicting upcoming tour date...");
       // Simulate neural network animation with a timeout
       setTimeout(async () => {
         try {
           const predictionData = {
             artistName: this.artistName,
             hottestTracks: this.hottestTracks,
             monthlyListeners: this.monthlyListeners,
             fanEngagement: this.fanEngagement,
             top100artistranking: this.top100artistranking,
             pastEventDates: this.pastEventDates,
           };
 
           const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}/predict-tour-date`, {
             method: "POST",
             headers: { "Content-Type": "application/json" },
             body: JSON.stringify(predictionData),
           });

           const data = await response.json();
           this.predictedTourDate = data.predictedTourDate;
 
           // Text-to-Speech
           this.readOutLoud(`The predicted upcoming tour date is ${this.predictedTourDate}`);
         } catch (error) {
           console.error("Prediction error:", error);
           this.showError("Error during prediction. Please try again.");
           alert("Error during prediction. Please try again.");
         } finally {
           this.isPredicting = false;
         }
       }, 3000);
     },
     isPredictionDataComplete() {
   const requiredFields = [
     { field: "artistName", label: "Artist Name" },
     { field: "hottestTracks", label: "Hottest Tracks" },
     { field: "monthlyListeners", label: "Monthly Listeners" },
     { field: "fanEngagement", label: "Fan Engagement" },
   ];
 
   this.missingData = requiredFields
     .filter(({ field }) => !this[field] || this[field].trim() === "")
     .map(({ label }) => label);
 
   return this.missingData.length === 0;
 },

     validateInputs() {
   if (!this.artistName) return "Artist Name is required.";
   if (!this.monthlyListeners || isNaN(this.monthlyListeners))
     return "Monthly Listeners must be a valid number.";
   if (this.artistEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.artistEmail))
     return "Invalid email format.";
   return null; // No errors
 },
 triggerNewsSearch() {
   // Wait for 3 seconds before activating fetchNews
   this.readOutLoud("Fetching online sources...");
   setTimeout(() => {
     // If no domains are selected, use defaults
     if (this.selectedDomains.length === 0) {
       this.selectedDomains = ["cnn.com", "theverge.com", "google.com", "billboard.com", "songkick.com/leaderboards/popular_artists", "bloomberg.com"];
     }
     this.fetchNews(); // Trigger the news search
   }, 7000);
   setTimeout(() => {
     this.searchArtist(); // Trigger the artist search
   }, 12000);
 },

 async fetchNews() {
  setTimeout(() => {
    if (!this.searchQuery) {
      alert("Please enter a search term.");
      this.readOutLoud("Please enter a search term.");
      return;
    }
  }, 10000);

  this.loading = true;
  this.articles = [];


  const baseUrl = "https://newsapi.org/v2/everything";
  const apiKey = "322c01340c6a449c8a61b4cb35c80e39";

  const params = new URLSearchParams({
    q: this.searchQuery,
    from: this.fromDate,
    to: this.toDate,
    sortBy: this.sortBy,
    domains: this.selectedDomains.join(","),
    apiKey,
  });

  try {
    const response = await fetch(`${baseUrl}?${params}`);
    if (!response.ok) throw new Error("Failed to fetch news articles.");

    const data = await response.json();
    this.articles = data.articles;

    this.articles.forEach((article) => this.saveArticleToProfile(article));
    setTimeout(() => {
      this.readOutLoud("Proceeding to the next step.");
      this.isExpanded = false;
    }, 2000);
    this.currentStep = 2;
    this.notifyStepComplete("News");
    this.readOutLoud("News articles fetched successfully!");
    setTimeout(() => {
      const requiredFields = [
        { field: "artistName", label: "Artist Name" },
    { field: "monthlyListeners", label: "Monthly Listeners" },
    { field: "hottestTracks", label: "Hottest Tracks" },
    { field: "fanEngagement", label: "Fan Engagement" },
    { field: "artistLabelSignedTo", label:  "Record Label" },
    { field: "details", label: "Details" },
  ];
      this.missingData = requiredFields
    .filter(({ field }) => !this[field] || this[field].trim() === "")
    .map(({ label }) => label);
    this.collectedDataPoints = requiredFields.length - this.missingData.length;
    this.updateThermometer();
  
    if (this.missingData.length > 0) {
    this.showNotification(`Missing data: ${this.missingData.join(", ")}`);
    return;
    }
    this.showNotification("All data points collected successfully!");
    }, 3000);
  } catch (err) {
    console.error(err);
    this.error = "Error fetching news articles.";
    this.readOutLoud("Error fetching news articles.");
  } finally {
    this.loading = false;
  }
},

 notifyAndSpeak(message) {
         this.$refs.notifications.addNotification(message, 'info');
         this.readOutLoud(message);
       },
     toggleCardSize(index) {
       this.expandedIndex = this.expandedIndex === index ? null : index;
     },
 updateArtistImage(index, imageUrl) {
     if (!imageUrl) {
       alert("Please provide a valid image URL.");
       return;
     }
     this.$set(this.artistProfiles[index], "image", imageUrl);
     localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
           this.notifyAndSpeak('Image Saved Successfully');
   },
   removeArtistImage(index) {
     this.$set(this.artistProfiles[index], "image", null);
     localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
     this.notifyAndSpeak('Image removed Successfully');
   },
   async fetchArtistImage(index) {
     const artistName = this.artistProfiles[index].artistName;
     try {
       const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({ artistName }),
       });
       const data = await response.json();
       if (data.imageUrl) {
         this.$set(this.artistProfiles[index], "image", data.imageUrl);
         localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
         alert("Image fetched and added successfully!");
       } else {
         alert("Unable to find an image for the artist.");
       }
     } catch (err) {
       console.error("Error fetching image:", err);
       alert("Failed to fetch artist image.");
     }
   },
//    editArtistProfile(index) {
//    this.editingProfileIndex = index;
//    const profile = this.artistProfiles[index];

//    this.artistName = profile.artistName;
//    this.artistLabelSignedTo = profile.artistLabelSignedTo;
//    this.artistManager = profile.artistManager;
//    this.artistEmail = profile.artistEmail;
//    this.artistPhone = profile.artistPhone;
//    this.artistLightingDesigner = profile.artistLightingDesigner;
//    this.artistLightingDesignerEmail = profile.artistLightingDesignerEmail;
//    this.artistLightingDesignerPhone = profile.artistLightingDesignerPhone;
//    this.artistProductionManager = profile.artistProductionManager;
//    this.artistProductionManagerEmail = profile.artistProductionManagerEmail;
//    this.artistProductionManagerPhone = profile.artistProductionManagerPhone;
//    this.artistTourManager = profile.artistTourManager;
//    this.artistTourManagerEmail = profile.artistTourManagerEmail;
//    this.artistTourManagerPhone = profile.artistTourManagerPhone;
//    this.artistBusinessManager = profile.artistBusinessManager;
//    this.artistBusinessManagerEmail = profile.artistBusinessManagerEmail;
//    this.artistBusinessManagerPhone = profile.artistBusinessManagerPhone;
//    this.artistVideoDesigner = profile.artistVideoDesigner;
//    this.artistVideoDesignerEmail = profile.artistVideoDesignerEmail;
//    this.artistVideoDesignerPhone = profile.artistVideoDesignerPhone;
//    this.artistFrontOfHouseEngineer = profile.artistFrontOfHouseEngineer;
//    this.artistFrontOfHouseEngineerEmail = profile.artistFrontOfHouseEngineerEmail;
//    this.artistFrontOfHouseEngineerPhone = profile.artistFrontOfHouseEngineerPhone;
//    this.artistSetDesigner = profile.artistSetDesigner;
//    this.artistSetDesignerEmail = profile.artistSetDesignerEmail;
//    this.artistSetDesignerPhone = profile.artistSetDesignerPhone;
//    this.artistWebsite = profile.artistWebsite;
//    this.artistSocialMedia = profile.artistSocialMedia;
//    this.artistBio = profile.artistBio;
//    this.hottestTracks = profile.hottestTracks;
//    this.monthlyListeners = profile.monthlyListeners;
//    this.fanEngagement = profile.fanEngagement;
//    this.preferredVenues = profile.preferredVenues;
//    this.pastEventDates = profile.pastEventDates;
//    this.genre = profile.genre;
//    this.top100artistranking = profile.top100artistranking;
//    this.details = profile.details;
//    this.queryPrompt = profile.query;
//    this.articles = profile.newsArticles;
//    this.predictedTourDate = profile.predictedTourDate;
//    this.artistData = null;
   
 
//    // Save profile to localStorage
//    localStorage.setItem("selectedArtistProfile", JSON.stringify(profile));

// // Navigate to /artistTracker
// this.$router.push({ path: "/artistTracker" });
//    this.searchQuery = profile.artistName;
//    this.artistQuery = profile.artistName;
 
//    this.isExpanded = true;
//    Object.assign(this.$data, profile);
//  },
// editArtistProfile(index) {
//   const profile = this.artistProfiles[index];

//   localStorage.setItem("selectedArtistProfile", JSON.stringify(profile));

//   this.$router.push({ path: "/artistTracker" });
// },
 
editArtistProfile(index) {
  const profile = this.artistProfiles[index];
  localStorage.setItem("selectedArtistProfile", JSON.stringify(profile));
  this.$router.push("/artistTracker");
},
saveEditedProfile() {
  if (this.editingProfileIndex !== -1) {
        const profile = this.artistProfiles[this.editingProfileIndex];
        const updatedProfile = {
          artistName: this.artistName,
          artistLabelSignedTo: this.artistLabelSignedTo,
          artistManager: this.artistManager,
          artistEmail: this.artistEmail,
          artistPhone: this.artistPhone,
          artistWebsite: this.artistWebsite,
          artistLightingDesigner: this.artistLightingDesigner,
          artistLightingDesignerEmail: this.artistLightingDesignerEmail,
          artistLightingDesignerPhone: this.artistLightingDesignerPhone,
          artistProductionManager: this.artistProductionManager,
          artistProductionManagerEmail: this.artistProductionManagerEmail,
          artistProductionManagerPhone: this.artistProductionManagerPhone,
          artistTourManager: this.artistTourManager,
          artistTourManagerEmail: this.artistTourManagerEmail,
          artistTourManagerPhone: this.artistTourManagerPhone,
          artistBusinessManager: this.artistBusinessManager,
          artistBusinessManagerEmail: this.artistBusinessManagerEmail,
          artistBusinessManagerPhone: this.artistBusinessManagerPhone,
          artistVideoDesigner: this.artistVideoDesigner,
          artistVideoDesignerEmail: this.artistVideoDesignerEmail,
          artistVideoDesignerPhone: this.artistVideoDesignerPhone,
          artistFrontOfHouseEngineer: this.artistFrontOfHouseEngineer,
          artistFrontOfHouseEngineerEmail: this.artistFrontOfHouseEngineerEmail,
          artistFrontOfHouseEngineerPhone: this.artistFrontOfHouseEngineerPhone,
          artistSetDesigner: this.artistSetDesigner,
          artistSetDesignerEmail: this.artistSetDesignerEmail,
          artistSetDesignerPhone: this.artistSetDesignerPhone,
          artistSocialMedia: this.artistSocialMedia,
          artistBio: this.artistBio,
          hottestTracks: this.hottestTracks,
          monthlyListeners: this.monthlyListeners,
          fanEngagement: this.fanEngagement,
          preferredVenues: this.preferredVenues,
          pastEventDates: this.pastEventDates,
          genre: this.genre,
          top100artistranking: this.top100artistranking,
          details: this.details,
          newsArticles: this.articles,
          predictedTourDate: this.predictedTourDate,
          image: this.artistData?.images[0]?.url || profile.image,
          date: new Date().toLocaleString(),
        };
    this.$set(this.artistProfiles, this.editingProfileIndex, updatedProfile);
    // Save the edited data back to the profile
    this.$set(this.artistProfiles, this.editingProfileIndex, {
      artistName: this.artistName,
      artistLabelSignedTo: this.artistLabelSignedTo,
      artistManager: this.artistManager,
      artistEmail: this.artistEmail,
      artistPhone: this.artistPhone,
      artistWebsite: this.artistWebsite,
      artistLightingDesigner: this.artistLightingDesigner,
      artistLightingDesignerEmail: this.artistLightingDesignerEmail,
      artistLightingDesignerPhone: this.artistLightingDesignerPhone,
      artistProductionManager: this.artistProductionManager,
      artistProductionManagerEmail: this.artistProductionManagerEmail,
      artistProductionManagerPhone: this.artistProductionManagerPhone,
      artistTourManager: this.artistTourManager,
      artistTourManagerEmail: this.artistTourManagerEmail,
      artistTourManagerPhone: this.artistTourManagerPhone,
      artistBusinessManager: this.artistBusinessManager,
      artistBusinessManagerEmail: this.artistBusinessManagerEmail,
      artistBusinessManagerPhone: this.artistBusinessManagerPhone,
      artistVideoDesigner: this.artistVideoDesigner,
      artistVideoDesignerEmail: this.artistVideoDesignerEmail,
      artistVideoDesignerPhone: this.artistVideoDesignerPhone,
      artistFrontOfHouseEngineer: this.artistFrontOfHouseEngineer,
      artistFrontOfHouseEngineerEmail: this.artistFrontOfHouseEngineerEmail,
      artistFrontOfHouseEngineerPhone: this.artistFrontOfHouseEngineerPhone,
      artistSetDesigner: this.artistSetDesigner,
      artistSetDesignerEmail: this.artistSetDesignerEmail,
      artistSetDesignerPhone: this.artistSetDesignerPhone,
      artistSocialMedia: this.artistSocialMedia,
      artistBio: this.artistBio,
      hottestTracks: this.hottestTracks,
      monthlyListeners: this.monthlyListeners,
      fanEngagement: this.fanEngagement,
      preferredVenues: this.preferredVenues,
      pastEventDates: this.pastEventDates,
      genre: this.genre,
      top100artistranking: this.top100artistranking,
      details: this.details,
      newsArticles: this.articles,
      predictedTourDate: this.predictedTourDate,
      image: this.artistData.images[0]?.url || profile.image, // Save artist image
      date: new Date().toLocaleString(),
      topTracks: this.topTracks,
      newReleases: this.newReleases,
      shows: this.shows,
      ticketmasterEvents: this.ticketmasterEvents,
      albumTracks: this.albumTracks,
      getAlbumTracks: this.getAlbumTracks,
      getTopTracks: this.getTopTracks,
      getNewReleases: this.getNewReleases,
      getShows: this.getShows,
      getTicketmasterEvents: this.getTicketmasterEvents,
    });

    // Save updated fields
    profile.artistName = this.artistName;
    profile.monthlyListeners = this.monthlyListeners;
    profile.fanEngagement = this.fanEngagement;
    profile.pastEventDates = this.pastEventDates;
    profile.hottestTracks = this.hottestTracks;
    profile.top100artistranking = this.top100artistranking;
    profile.details = this.details;
    profile.date = new Date().toLocaleString();

    // Save News Articles
    profile.newsArticles = this.articles;

    // Save Predicted Tour Date
    profile.predictedTourDate = this.predictedTourDate;

    // Save Artist Image
    profile.image = this.artistData.images[0]?.url || profile.image;

    // Merge the updates into the profile
    Object.assign(profile, updatedProfile);

    // Update localStorage
    localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));

    this.triggerConfetti();
    this.editingProfileIndex = -1;
    this.resetForm();
  }
},

   deleteArtistProfile(index) {
     if (confirm("Are you sure you want to delete this profile?")) {
       this.artistProfiles.splice(index, 1);
       localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
     }
     this.artistProfiles.splice(index, 1);
   },
     editQuery(index) {
       const query = this.savedQueries[index];
       this.artistName = query.artistName;
       this.artistLabelSignedTo = query.artistLabelSignedTo;
       this.artistManager = query.artistManager;
       this.artistEmail = query.artistEmail;
       this.artistPhone = query.artistPhone;
       this.artistWebsite = query.artistWebsite;
       this.artistLightingDesigner = query.artistLightingDesigner;
       this.artistLightingDesignerEmail = query.artistLightingDesignerEmail;
       this.artistLightingDesignerPhone = query.artistLightingDesignerPhone;
       this.artistProductionManager = query.artistProductionManager;
       this.artistProductionManagerEmail = query.artistProductionManagerEmail;
       this.artistProductionManagerPhone = query.artistProductionManagerPhone;
       this.artistTourManager = query.artistTourManager;
       this.artistTourManagerEmail = query.artistTourManagerEmail;
       this.artistTourManagerPhone = query.artistTourManagerPhone;
       this.artistBusinessManager = query.artistBusinessManager;
       this.artistBusinessManagerEmail = query.artistBusinessManagerEmail;
       this.artistBusinessManagerPhone = query.artistBusinessManagerPhone;
       this.artistVideoDesigner = query.artistVideoDesigner;
       this.artistVideoDesignerEmail = query.artistVideoDesignerEmail;
       this.artistVideoDesignerPhone = query.artistVideoDesignerPhone;
       this.artistFrontOfHouseEngineer = query.artistFrontOfHouseEngineer;
       this.artistFrontOfHouseEngineerEmail = query.artistFrontOfHouseEngineerEmail;
       this.artistFrontOfHouseEngineerPhone = query.artistFrontOfHouseEngineerPhone;
       this.artistSetDesigner = query.artistSetDesigner;
       this.artistSetDesignerEmail = query.artistSetDesignerEmail;
       this.artistSetDesignerPhone = query.artistSetDesignerPhone;
       this.artistSocialMedia = query.artistSocialMedia;
       this.artistBio = query.artistBio;
       this.hottestTracks = query.hottestTracks;
       this.monthlyListeners = query.monthlyListeners;
       this.fanEngagement = query.fanEngagement;
       this.preferredVenues = query.preferredVenues;
       this.pastEventDates = query.pastEventDates;
       this.genre = query.genre;
       this.top100artistranking = query.top100artistranking;
       this.details = query.details;
       this.queryPrompt = query.query;
       this.editingQueryIndex = index;
     },
     deleteQuery(index) {
       this.savedQueries.splice(index, 1);
       localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
     },
     processArtistData(content) {
     const artistData = {
       artistName: content.artistName || "Unknown",
       details: content.details || "No details found",
       date: new Date().toLocaleString(),
     };
     this.savedQueries.push(artistData);
     localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
 
     this.$nextTick(() => {
       const newCard = this.$refs.newArtistCard?.[0];
       if (newCard) {
         newCard.scrollIntoView({ behavior: "smooth", block: "center" });
         document.getElementById('artistnew').scrollIntoView({ behavior: 'smooth' });
       }
     });
   },
   processFoundData(content) {
   const regexes = {
     artistName: /Artist Name:\s*(.+)/i,
     artistLabelSignedTo: /Record Label:\s*(.+)/i,
     artistManager: /Artist Manager:\s*(.+)/i,
     artistEmail: /Artist Email:\s*(.+)/i,
     artistPhone: /Artist Phone:\s*(.+)/i,
     artistLightingDesigner: /Artist Lighting Designer:\s*(.+)/i,
     artistLightingDesignerEmail: /Artist Lighting Designer Email:\s*(.+)/i,
     artistLightingDesignerPhone: /Artist Lighting Designer Phone:\s*(.+)/i,
     artistProductionManager: /Artist Production Manager:\s*(.+)/i,
     artistProductionManagerEmail: /Artist Production Manager Email:\s*(.+)/i,
     artistProductionManagerPhone: /Artist Production Manager Phone:\s*(.+)/i,
     artistTourManager: /Artist Tour Manager:\s*(.+)/i,
     artistTourManagerEmail: /Artist Tour Manager Email:\s*(.+)/i,
     artistTourManagerPhone: /Artist Tour Manager Phone:\s*(.+)/i,
     artistBusinessManager: /Artist Business Manager:\s*(.+)/i,
     artistBusinessManagerEmail: /Artist Business Manager Email:\s*(.+)/i,
     artistBusinessManagerPhone: /Artist Business Manager Phone:\s*(.+)/i,
     artistVideoDesigner: /Artist Video Designer:\s*(.+)/i,
     artistVideoDesignerEmail: /Artist Video Designer Email:\s*(.+)/i,
     artistVideoDesignerPhone: /Artist Video Designer Phone:\s*(.+)/i,
     artistFrontOfHouseEngineer: /Artist Front Of House Engineer:\s*(.+)/i,
     artistFrontOfHouseEngineerEmail: /Artist Front Of House Engineer Email:\s*(.+)/i,
     artistFrontOfHouseEngineerPhone: /Artist Front Of House Engineer Phone:\s*(.+)/i,
     artistSetDesigner: /Artist Set Designer:\s*(.+)/i,
     artistSetDesignerEmail: /Artist Set Designer Email:\s*(.+)/i,
     artistSetDesignerPhone: /Artist Set Designer Phone:\s*(.+)/i,
     artistWebsite: /Artist Website:\s*(.+)/i,
     artistSocialMedia: /Artist Social Media:\s*(.+)/i,
     artistBio: /Artist Bio:\s*(.+)/i,
     hottestTracks: /Hottest Tracks:\s*(.+)/i,
     monthlyListeners: /Monthly Listeners:\s*(.+)/i,
     fanEngagement: /Fan Engagement:\s*(.+)/i,
     preferredVenues: /Preferred Locations:\s*(.+)/i,
     pastEventDates: /Past Event Dates:\s*(.+)/i,
     genre: /Genre:\s*(.+)/i,
     top100artistranking: /Top 100 Ranking:\s*(.+)/i,
     details: /Details:\s*(.+)/i,
     articles: /News Articles:\s*(.+)/i,
   };
 
   const artistData = {};
   for (const [field, regex] of Object.entries(regexes)) {
     const match = content.message.match(regex);
     artistData[field] = match ? match[1].trim() : "N/A";
   }
 
   // Save profile
   this.saveArtistProfile(artistData);
 },
saveArticleToProfile(article) {
  // Determine which profile to update: could be an active profile being edited or a default one.
  let profileIndex = this.editingProfileIndex !== -1 ? this.editingProfileIndex : this.artistProfiles.findIndex(p => p.artistName === this.artistQuery);

  if (profileIndex !== -1) {
    const profile = this.artistProfiles[profileIndex];

    // Ensure the profile has a `newsArticles` array
    if (!profile.newsArticles) {
      this.$set(profile, "newsArticles", []);
    }

    // Add article if not already in the array
    if (!profile.newsArticles.some(a => a.title === article.title)) {
      profile.newsArticles.push(article);
    }

    // Update localStorage
    localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
  } else {
    // If no profile is being edited or matches, log an error or handle accordingly
    console.error("No active or matching profile found to save the article.");
    // Optionally, create a new profile or notify the user
  }
},

 
     extractArtistData(message) {
       const regexes = {
         artistName: /Artist Name:\s*(.+)/i,
         hottestTracks: /Hottest Tracks:\s*(.+)/i,
         monthlyListeners: /Monthly Listeners:\s*(.+)/i,
         fanEngagement: /Fan Engagement:\s*(.+)/i,
         preferredVenues: /Preferred Venues:\s*(.+)/i,
         pastEventDates: /Past Event Dates:\s*(.+)/i,
         genre: /Genre:\s*(.+)/i,
         top100artistranking: /Top 100 Ranking:\s*(.+)/i,
         details: /Details:\s*(.+)/i,
       };
 
       const artistData = {};
       for (const [key, regex] of Object.entries(regexes)) {
         const match = message.match(regex);
         artistData[key] = match ? match[1].trim() : null;
       }
       return artistData;
     },
     saveArtistProfile(data) {
       const profile = {
         ...data,
         date: new Date().toLocaleString(),
       };
       this.artistProfiles.push(profile);
       localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
     },
     updateMissingData(data) {
      const requiredFields = [
    "artistName", "hottestTracks", "monthlyListeners", "fanEngagement",
    "preferredVenues", "pastEventDates", "genre", "top100artistranking"
  ];
      
     this.missingData = requiredFields.filter(field => !data[field]);
     this.collectedDataPoints = requiredFields.length - this.missingData.length;
     this.updateThermometer();
     },
     predictTourDate() {
  // Step 1: Validate Required Fields
  const requiredFields = [
    { field: "artistName", label: "Artist Name" },
    { field: "monthlyListeners", label: "Monthly Listeners" },
    { field: "fanEngagement", label: "Fan Engagement" },
    { field: "pastEventDates", label: "Past Event Dates" },
    { field: "hottestTracks", label: "Hottest Tracks" },
    { field: "artistLabelSignedTo", label:  "Record Label" },
    { field: "top100artistranking", label: "Top 100 Artist Ranking" },
    { field: "artistManager", label: "Artist Manager" },
    { field: "artistEmail", label: "Artist Email" },
    { field: "artistPhone", label: "Artist Phone" },
    { field: "artistWebsite", label: "Artist Website" },
    { field: "artistSocialMedia", label: "Artist Social Media" },
    { field: "artistBio", label: "Artist Bio" },
    { field: "details", label: "Details" },
  ];

  this.missingData = requiredFields
    .filter(({ field }) => !this[field] || this[field].trim() === "")
    .map(({ label }) => label);

    // Update collected data points
  this.collectedDataPoints = requiredFields.length - this.missingData.length;
  this.updateThermometer();

  if (this.missingData.length > 0) {
    this.showNotification(`Missing data: ${this.missingData.join(", ")}`);
    this.scrollToStep(1);
    return;
  }

  // Step 2: Prepare Prediction Data
  const predictionData = {
    artistName: this.artistName,
    monthlyListeners: this.monthlyListeners,
    fanEngagement: this.fanEngagement,
    pastEventDates: this.pastEventDates,
    hottestTracks: this.hottestTracks,
    top100artistranking: this.top100artistranking,
  };

  // Step 3: Transition to Predicting State
  this.isPredicting = true;
  this.loadingText = "Analyzing data to predict tour date...";
  this.showNotification("Analyzing data to predict tour date...");
  this.readOutLoud("Analyzing data to predict tour date...");

  this.predictTourDateFromServer(predictionData);

  // Step 4: Simulate API Call with Fetch
  fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(predictionData),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      this.predictedTourDate = data.predictedDate || "No prediction available";
      this.showNotification("Tour date successfully predicted!");
      this.notifyStepComplete("Tour Date Prediction");
      // Step 5: Move to Step 3 and Scroll
      this.currentStep = 3;
      this.scrollToStep(3);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 6000);
      setTimeout(() => {
        this.saveEditedProfile();
      }, 8000);
      setTimeout(() => {
        location.reload();
      }, 16000);
    })
    
    .catch((error) => {
      console.error("Prediction error:", error);
      this.showNotification("An error occurred during the prediction.");
    })
    .finally(() => {
      this.isPredicting = false;
    });
},
async predictTourDateFromServer(data) {
  try {
    const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    this.predictedTourDate = result.predictedDate || "No prediction available";
    this.showNotification("Tour date successfully predicted!");
  } catch (error) {
    console.error("Prediction error:", error);
    this.showNotification("An error occurred during the prediction.");
  }
},

updateThermometer() {
  const percentage = (this.collectedDataPoints / this.totalDataPoints) * 100;
  this.thermometerFill = `${percentage}%`;
  this.likelihoodCategory = percentage < 20 ? "Unlikely" : percentage < 50 ? "Possible" : percentage < 70 ? "Probable" : "Likely";
},


     resetPrediction() {
       this.predictedTourDate = null;
       this.isPredicting = false;
     },
 resetForm() {
   this.queryPrompt = "";
   this.artistName = "";
   this.artistLabelSignedTo = "";
   this.artistManager = "";
   this.artistEmail = "";
   this.artistPhone = "";
   this.artistLightingDesigner = "";
   this.artistLightingDesignerEmail = "";
   this.artistLightingDesignerPhone = "";
   this.artistProductionManager = "";
   this.artistProductionManagerEmail = "";
   this.artistProductionManagerPhone = "";
   this.artistTourManager = "";
   this.artistTourManagerEmail = "";
   this.artistTourManagerPhone = "";
   this.artistBusinessManager = "";
   this.artistBusinessManagerEmail = "";
   this.artistBusinessManagerPhone = "";
   this.artistVideoDesigner = "";
   this.artistVideoDesignerEmail = "";
   this.artistVideoDesignerPhone = "";
   this.artistFrontOfHouseEngineer = "";
   this.artistFrontOfHouseEngineerEmail = "";
   this.artistFrontOfHouseEngineerPhone = "";
   this.artistSetDesigner = "";
   this.artistSetDesignerEmail = "";
   this.artistSetDesignerPhone = "";
   this.artistWebsite = "";
   this.artistSocialMedia = "";
   this.artistBio = "";
   this.hottestTracks = "";
   this.monthlyListeners = "";
   this.fanEngagement = "";
   this.preferredVenues = "";
   this.pastEventDates = "";
   this.genre = "";
   this.top100artistranking = "";
   this.details = "";
   this.editingProfileIndex = -1; // Reset editing state
   this.showNotification("Form has been reset.");
 },
 
   },
 };
 </script>
 
 
 
 
 <style scoped>
.ai-header-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  padding: 60px 20px 40px;
  margin-bottom: 30px;
  background: linear-gradient(135deg, rgba(5, 8, 14, 0.9), rgba(20, 40, 70, 0.85));
  box-shadow: 0 0 10px rgba(98, 0, 234, 0.4);
}

.ai-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.ai-brain-background {
  width: 100%;
  height: 100%;
  stroke: rgba(255, 255, 255, 0.05);
  stroke-width: 0.3;
  fill: rgba(255, 255, 255, 0.02);
  animation: brainThinking 15s infinite alternate ease-in-out;
  opacity: 0.5;
}

@keyframes brainThinking {
  0% {
    transform: scale(1) translateY(0px);
  }
  50% {
    transform: scale(1.05) translateY(-10px);
  }
  100% {
    transform: scale(1) translateY(0px);
  }
}

.ai-header-content {
  position: relative;
  z-index: 1;
}

.ai-icon {
  font-size: 60px;
  margin-bottom: 15px;
  animation: pulseGlow 2s infinite;
}

@keyframes pulseGlow {
  0% {
    text-shadow: 0 0 5px #00fff2;
  }
  50% {
    text-shadow: 0 0 15px #00fff2;
  }
  100% {
    text-shadow: 0 0 5px #00fff2;
  }
}

.ai-title {
  color: #ffffff;
  font-family: 'Lato', sans-serif;
  font-weight: 200;
  font-size: 2.6rem;
  margin: 0;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.ai-subtitle {
  color: #b2ebf2;
  font-family: 'Rajdhani', sans-serif;
  font-size: 1.2rem;
  margin-top: 10px;
}

 form {
   margin: 20px 0;
 }
 .floating-legend {
  position: sticky;
  background: linear-gradient(135deg, rgba(8, 8, 24, 0.8), rgba(16, 16, 49, 0.8));
  color: white;
  padding: 1rem;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  min-width: 760px;
  max-width: 98%; /* Ensure it fits within the page */
  z-index: 9999;
  overflow: auto;
  animation: fadeIn 0.5s ease-in-out;
  cursor: move;
}

/* Data Summary Row */
.data-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.data-summary-row p {
  margin: 0;
  padding: 0 10%;
  font-size: 1.2rem;
  font-weight: bold;
}

/* Data Status */
.data-status {
  margin-bottom: 0.5rem;
}

.data-status p {
  margin: 0;
  font-size: 0.85rem;
}

.data-status p.collected {
  color: limegreen;
  font-weight: bold;
}

.data-status p:not(.collected) {
  color: crimson;
  font-weight: bold;
}

/* AI Search Section */
.ai-search {
  margin-top: 1rem;
}

.ai-search p {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.ai-search v-btn {
  margin-right: 0.5rem;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .floating-legend {
    min-width: 100%;
    padding: 0.8rem;
  }

  .data-summary-row p {
    font-size: 0.8rem;
  }

  .data-status p {
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .floating-legend {
    padding: 0.5rem;
  }

  .data-summary-row p {
    font-size: 0.7rem;
  }

  .data-status p {
    font-size: 0.65rem;
  }
}
/* Legend Header */
.legend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
}

.legend-header h3 {
  font-size: 1.2rem;
  margin: 0;
}

.legend-content {
  margin-top: 1rem;
}

/* Data Status List */
.data-status {
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.data-status p {
  margin: 0;
  font-size: 0.9rem;
}

.data-status p.collected {
  color: limegreen;
  font-weight: bold;
  animation: collectedAnimation 1s ease-in-out;
}

.data-status p:not(.collected) {
  color: crimson;
  font-weight: bold;
  animation: pendingAnimation 1s ease-in-out;
}

/* AI Search Section */
.ai-search {
  margin-top: 1rem;
}

.ai-search p {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.ai-search v-btn {
  margin-right: 0.5rem;
}

/* Resize Handle */
.floating-legend::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  cursor: nwse-resize;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes collectedAnimation {
  from {
    color: gray;
    transform: scale(1.1);
  }
  to {
    color: limegreen;
    transform: scale(1);
  }
}

@keyframes pendingAnimation {
  from {
    color: gray;
    transform: scale(1.1);
  }
  to {
    color: crimson;
    transform: scale(1);
  }
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .floating-legend {
    width: 90%;
    padding: 0.8rem;
  }

  .legend-header h3 {
    font-size: 1rem;
  }

  .data-status p {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .floating-legend {
    width: 100%;
    padding: 0.5rem;
  }

  .legend-header h3 {
    font-size: 0.9rem;
  }

  .data-status p {
    font-size: 0.7rem;
  }
}
 .download-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: -10px;
  opacity: 0.8;
}
.save-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 0px;
  opacity: 0.8;
}
.close-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 10px;
  opacity: 0.8;
}
.overlay2 {
  background: rgba(0, 0, 0, 0.5);
  border: #000;
  border-radius: 10px;
  color: white;
  width: 100%;
  text-align: center;
  padding: 10px 10px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0c161b2f; /* Semi-transparent background */
}
.inputarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-sizing: border-box;
  resize: vertical;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
  color: #000;
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  width: 800px;
  height: 600px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 900px) {
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
 textarea {
   width: 100%;
   padding: 10px;
   font-size: 16px;
   color: white;
   border: 1px solid #ccc;
   border-radius: 8px;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   resize: none;
 }
 body {
   font-family: Arial, sans-serif;
 }
 .floating-legend-2 {
  position: fixed;
  top: 11.5%;
  right: 25px;
  width: 100px;
  background-color: rgba(12, 22, 27, 0.2);
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}
.expand-icon {
  cursor: pointer;
  src: url(https://cdn-icons-png.flaticon.com/512/1828/1828928.png);
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  width: 1550px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #3e2186;
  color: white;
  border-radius: 5px 5px 0 0;
}
.card-header h2 {
  margin: 0;
}
.card-content {
  padding: 20px;
  border-radius: 0 0 5px 5px;
}

.thermometer {
  width: 50px;
  height: 150px;
  background: #ccc;
  border-radius: 20px;
  overflow: hidden;
  margin: 0 auto 10px;
  position: relative;
}

.thermometer-fill {
  width: 100%;
  background: linear-gradient(to top, #ff0000, #00ff00);
  position: absolute;
  bottom: 0;
  transition: height 0.5s ease-in-out;
}

.legend {
  text-align: center;
  color: #fff;
}

.legend p {
  margin: 5px 0;
  opacity: 0.5;
  font-weight: normal;
  transform: scale(0.8);
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}

.legend p.active {
  opacity: 1;
  font-weight: bold;
  transform: scale(1.1);
  color: #388e3c;
}
 .profile-card.expanded {
   transform: scale(1.05);
   height: auto;
 }
 /* .profile-card2 {
   border: 2px solid #3e2186;
   border-radius: 50%;
   padding: 10px;
   margin: 10px 0;
   transition: transform 0.3s ease, height 0.3s ease;
   overflow: hidden;
   cursor: pointer;
   width: 200px;
   height: 200px;
 } */
 .profile-card2.expanded {
   transform: scale(1.05);
   border-radius: 5%;
   height: auto;
   padding: 30px 30px 30px 30px;
   margin: 10px 10px 10px 10px;
   transition: transform 0.3s ease, height 0.3s ease;
   overflow: hidden;
   cursor: pointer;
   width: 500px;
   background: rgba(25, 12, 31, 0.503);
 }
 .artist-image {
   width: 100px;
   height: 100px;
   object-fit: cover;
 }
 
 
 .progress-tracker {
   display: flex;
   justify-content: space-between;
   margin-bottom: 20px;
   cursor: pointer;
 }
 .progress-step {
   flex: 1;
   text-align: center;
   padding: 10px;
   background-color: #edefeb;
   color: #333;
   margin: 0 5px;
   border-radius: 10px;
 }
 .progress-step.active {
   background-color: #4caf50;
   color: white;
 }
 .form-control-6 {
   margin-bottom: 20px;
 }

 .news-articles {
   display: flex;
   flex-wrap: wrap;
 }
 .article-card {
   width: 200px;
   margin: 10px;
   padding: 10px;
   border: 1px solid #ccc;
   transition: transform 0.3s ease;
 }
 .article-card:hover {
   transform: scale(1.1);
 }
 
 /* Buttons */
 button {
   background-color: #4caf50;
   color: white;
   padding: 10px 15px;
   border: none;
   border-radius: 5px;
   cursor: pointer;
 }
 button:hover {
   background-color: #45a049;
 }
 .artistName {
   color: #78b59c;
   font-size: 18px;
   font-family: 'lato';
   font-weight: thin;
   font-stretch: expanded;
   text-align: center;
   left: 0%;
   right: 0px;
   margin-right: 30px;
   padding-block: 10px;
   padding-left: 10px;
   padding-right: 10px;
   text-decoration: none !important;
   outline-width: 1px;
   outline-color: #a8abb1;
     outline-style: solid;
     border-radius: 15px;
     animation: glow 2500ms ease-out infinite alternate;
     box-shadow: 0 0 3px rgba(90, 128, 191, 0.2),
     inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
 }
 @keyframes glow {
     0% {
       border-color: #11ece5;
       box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
         inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
     }
 
     100% {
       border-color: #11ece5;
       box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
         inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
     }
   }
   .artist-profiles {
   display: flex;
   flex-wrap: wrap;
   gap: 20px;
   margin-top: 40px;
   justify-content: center;
 }
 
 .profile-card2 {
   position: relative;
   width: 300px;
   height: 280px;
   padding: 16px;
   background: rgba(44, 53, 58, 0.973);
   border-radius: 8px;
   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
   text-align: center;
   overflow: hidden;
   cursor: pointer;
 }
 
 .profile-card2 h3 {
   margin-top: 16px;
 }
 
 /* Album and Vinyl Styles */
 .album-container {
   position: relative;
   width: 200px;
   height: 200px;
   margin: 0 auto;
 }
 
 .album-cover {
   position: relative;
   width: 100%;
   height: 100%;
   z-index: 2; /* Above the vinyl */
   border-radius: 4px;
   overflow: hidden;
   outline: 1px solid #ffffff64;
   animation: glow 1800ms ease-out infinite alternate;
   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
 }
 

 .cover-image2 {
   width: 100%;
   height: 100%;
   object-fit: fill;
   margin-top: 0px;
 }
 .vinyl-record {
   position: absolute;
   top: 0;
   left: 200px;
   width: 200px; /* Match the album cover size */
   height: 200px;
   z-index: 1; /* Behind the album cover */
   transform: translateX(-100%); /* Start hidden behind the cover */
   transition: transform 1s ease-in-out;
 }
 
 .vinyl-record.slide-out {
   transform: translateX(-80px); /* Adjust this value based on desired slide distance */
 }
 
 .vinyl-image {
   width: 100%;
   height: 100%;
   object-fit: cover;
   border-radius: 50%;
   animation: spinVinyl 5s linear infinite;
 }
 
 /* Vinyl Spinning Animation */
 @keyframes spinVinyl {
   0% {
     transform: rotate(0deg);
   }
   100% {
     transform: rotate(360deg);
   }
 }
 
 .profile-card3 {
   background: rgba(255, 255, 255, 0.1);
   padding: 20px 20px 20px 20px;
   color: #fff;
   border-radius: 20px;
   text-align: left;
   width: 100%;
   width: 100%;
   box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
   transition: transform 0.3s, box-shadow 0.3s;
   outline-width: 2px;
   outline-color: #5a80bf;
     outline-style: solid;
     border-radius: 10px;
     animation: glow 1800ms ease-out infinite alternate;
     box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
     inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
 }
 @keyframes glow {
     0% {
       border-color: #11ece5;
       box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
         inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
     }
 
     100% {
       border-color: #11ece5;
       box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
         inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
     }
   }
   
 
 .profile-card {
   background: rgba(255, 255, 255, 0.1);
   padding: 20px 20px 20px 20px;
   color: #fff;
   border-radius: 20px;
   text-align: left;
   width: 100%;
   width: 740px;
   box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
   transition: transform 0.3s, box-shadow 0.3s;
   outline-width: 2px;
   outline-color: #5a80bf;
     outline-style: solid;
     border-radius: 10px;
     animation: glow 1800ms ease-out infinite alternate;
     box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
     inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
 }
 @keyframes glow {
     0% {
       border-color: #11ece5;
       box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
         inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
     }
 
     100% {
       border-color: #11ece5;
       box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
         inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
     }
   }
 .inputarea2:focus {
   border-color: #6200ea;
   outline: none;
   box-shadow: 0 0 8px rgba(98, 0, 234, 0.5);
   font-size: 16px;
   color: white;
 }
 
 .inputarea2 {
   width: 100%;
   padding: 10px;
   font-size: 16px;
   color: white;
   border: 1px solid #ccc;
   border-radius: 8px;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   resize: none;
 }
 
 .artist-image-container {
   text-align: center;
   margin-top: 10px;
 }
 
 .artist-image {
   width: 225px;
   height: 225px;
   object-fit: cover;
   border-radius: 50%;
   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
 }
 
 .form-group {
   margin-top: 10px;
 }
 
 .v-btn {
   margin-left: 5px;
 }
 
 .saved-queries-container {
   background: rgba(0, 0, 0, 0.7);
   padding: 20px;
   border-radius: 10px;
   color: #fff;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
 }
 
 /* Grid styling for saved queries */
 .saved-queries-grid {
   display: flex;
   flex-wrap: wrap;
   gap: 20px;
   justify-content: center;
 }
 
 /* Individual query card styling */
 .saved-query-card {
   background: rgba(255, 255, 255, 0.1);
   padding: 20px;
   border-radius: 10px;
   text-align: left;
   width: 100%;
   max-width: 300px;
   box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
   transition: transform 0.3s, box-shadow 0.3s;
 }
 
 .saved-query-card:hover {
   transform: translateY(-5px);
   box-shadow: 0 8px 16px rgba(0, 255, 255, 0.4);
 }
 
 /* Action buttons in query cards */
 .action-buttons {
   margin-top: 10px;
   display: flex;
   justify-content: space-between;
 }
 
 /* Responsive design */
 @media screen and (max-width: 768px) {
   .saved-query-card {
     width: 100%;
   }
 }
 
 /* Text fields and buttons */
 .v-text-field {
   margin-bottom: 20px;
   color: white;
   background: rgb(255, 255, 255);
   text-transform: normal;
   font-weight: light;
 }
 
 .v-btn {
   margin: 5px;
   background-color: #6200ea;
   color: #000000;
   text-transform: uppercase;
   font-weight: bold;
 }
 
 .v-btn:hover {
   background: rgba(27, 13, 46, 0.551);
   color: #fff;
 }
 
 /* Loading and found data message */
 .loading-container {
   text-align: center;
   margin-top: 20px;
   font-size: 18px;
   color: #6200ea;
 }
 .activeButton {
  background: linear-gradient(135deg, rgba(98, 0, 234, 0.8), rgba(156, 39, 176, 0.6));
  color: #fff;
  border: 2px solid rgba(156, 39, 176, 0.8);
  border-radius: 12px;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 15px rgba(98, 0, 234, 0.8), 0 0 25px rgba(156, 39, 176, 0.7);
  outline: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: pulseAnimation 5s infinite, wiggleAnimation 5s infinite;
}

/* Hover Effect */
.activeButton:hover {
  transform: scale(1.1);
  box-shadow: 0 0 25px rgba(98, 0, 234, 1), 0 0 35px rgba(156, 39, 176, 1);
}

/* Active State */
.activeButton:active {
  transform: scale(0.95);
  box-shadow: 0 0 20px rgba(98, 0, 234, 0.9), 0 0 30px rgba(156, 39, 176, 0.8);
}

/* Pulse Animation */
@keyframes pulseAnimation {
  0% {
    box-shadow: 0 0 15px rgba(98, 0, 234, 0.8), 0 0 25px rgba(156, 39, 176, 0.7);
  }
  50% {
    box-shadow: 0 0 25px rgba(98, 0, 234, 1), 0 0 35px rgba(156, 39, 176, 1);
    transform: scale(1.05);
  }
  100% {
    box-shadow: 0 0 15px rgba(98, 0, 234, 0.8), 0 0 25px rgba(156, 39, 176, 0.7);
  }
}

/* Wiggle Animation */
@keyframes wiggleAnimation {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(2deg);
  }
  50% {
    transform: rotate(-2deg);
  }
  75% {
    transform: rotate(1deg);
  }
}

 .found-data-message {
   margin-top: 10px;
   padding: 10px;
   background-color: #e8f5e9;
   color: #388e3c;
   border: 1px solid #81c784;
   border-radius: 8px;
   font-weight: bold;
 }
 
 /* Form card layout */
 
 .chart-content-5 {
   background: rgba(0, 0, 0, 0.7);
   padding-block: 20px;
   border-radius: 10px;
   color: #fff;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
 }
 
 /* Responsive design */
 @media screen and (max-width: 768px) {
   textarea {
     font-size: 14px;
   }
 
   .v-btn {
     font-size: 14px;
     padding: 8px 16px;
   }
 
   .v-text-field {
     margin-bottom: 15px;
   }
 
   .chart-content-5 {
     padding: 15px;
   }
 }
 
 .top-artists-container {
   margin-top: 20px;
   background: rgba(0, 0, 0, 0.7);
   padding: 20px;
   border-radius: 10px;
   color: #fff;
   display: flex;
   flex-wrap: wrap;
   gap: 20px;
   justify-content: center;
 }
 
 .artist-card {
   background: rgba(255, 255, 255, 0.1);
   padding: 20px;
   border-radius: 10px;
   text-align: center;
   width: 100%;
   max-width: 1860px;
   box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
   transition: transform 0.3s, box-shadow 0.3s;
 }
 
 .artist-card:hover {
   transform: translateY(-5px);
   box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
 }
 @media screen and (max-width: 576px) {
   .chart-content-5 {
     padding: 10px;
   }
   .v-btn {
     font-size: 12px;
     padding: 5px 10px;
   }
 }
 main{
     display: flex;
     flex-wrap: wrap;
     gap: 20px;
     flex-basis: 60%;
     margin-left: auto;
     padding-bottom: 60px;
 }
 
 h1, p, h3{
     display: block;
     margin: 20px 10px 20px 10px;
     width: 100%;
 }
 
 h2{
     margin-left: 10px;
 }
 
 h3{
     text-align: center;
 }
 
 .news-search {
   color: #78b59c;
   font-size: 20px;
   font-family: 'lato';
   height: 100%;
 }
 .news-search2 {
   color: #78b59c;
   font-size: 20px;
   font-family: 'lato';
   background-color: rgba(12, 22, 27, 0.705);
   max-width: 1900px;
   padding: 100px 50px 50px 50px;
   margin-top: 20px;
   border-radius: 20px;
 }
 .news-search3 {
   color: #78b59c;
   font-size: 20px;
   font-family: 'lato';
   background-color: rgba(12, 22, 27, 0.705);
   max-width: 1900px;
   padding: 100px 50px 50px 50px;
   margin-top: 20px;
   border-radius: 20px;
 }
 
 form {
   margin-bottom: 0px;
 }
 
 form div {
   margin-bottom: 10px;
 }
 
 button {
   padding: 10px 20px;
   cursor: pointer;
 }
 
 .results {
   margin-top: 20px;
 }
 
 .article {
   flex-basis: 50%;
     display: flex;
     flex-wrap: wrap;
     justify-content: center;
     align-items: flex-start;
     background: rgba(12, 22, 27, 0.9);
     padding-bottom: 20px;
     padding-top: 20px;
     padding-block: 40px 40px 40px 40px;
     margin-block: 40px 40px 40px 40px;
     -webkit-box-shadow: 5px 5px 5px 5px #7D7D7D; 
     box-shadow: 5px 5px 5px 5px #7D7D7D;
     hyphens: auto;
 }
 
 .article-image {
   width: 100%;
     height: 220px;
     object-fit: cover;
     object-position: center;
 }
 
 .prediction-animation {
   text-align: center;
   margin: 20px;
 }
 .neural-network {
   display: flex;
   justify-content: center;
   margin-top: 20px;
 }
 .node {
   width: 15px;
   height: 15px;
   margin: 5px;
   background-color: #4caf50;
   border-radius: 50%;
   animation: pulse 1.5s infinite;
 }
 @keyframes pulse {
   0%, 100% {
     transform: scale(1);
     background-color: #4caf50;
   }
   50% {
     transform: scale(1.5);
     background-color: #81c784;
   }
 }
 .domainSelect {
   padding-block: 22px;
   margin-right: 22px;
   margin-left: 22px;
 }
 
 .textNews {
   color: #78b59c;
   font-size: 22px;
   font-family: 'lato';
   font-weight: thin;
   position: relative;
   left: 0%;
   right: 0px;
   margin-left: 20px;
 }
 
 .textNews2 {
   color: #fff;
   font-size: 22px;
   font-family: 'lato';
   font-weight: thin;
   position: relative;
   left: 0%;
   right: 0px;
   padding-right: 70px;
 }
 
 .textNews3 {
   color: #78b59c;
   font-size: 18px;
   font-family: 'lato';
   font-weight: thin;
   position: relative;
   left: 0%;
   right: 0px;
   margin-right: 30px;
   padding-block: 10px;
   padding-left: 10px;
   padding-right: 10px;
   text-decoration: none !important;
   outline-width: 2px;
   outline-color: #5a80bf;
     outline-style: solid;
     border-radius: 10px;
     animation: glow 1800ms ease-out infinite alternate;
     cursor: pointer;
     box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
     inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
 }
 @keyframes glow {
     0% {
       border-color: #11ece5;
       box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
         inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
     }
 
     100% {
       border-color: #11ece5;
       box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
         inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
     }
   }
   .textNews4 {
   color: #78b59c;
   font-size: 26px;
   font-family: 'lato';
   font-weight: bold;
   position: relative;
   left: -46%;
   right: 0px;
 }
 .buttonNews {
   text-decoration: none !important;
   background: #78b59c;
   border-radius: 20px;
   padding: 20px;
   margin-top: 20px;
   margin-bottom: 0px;
   width: 250px;
   border: outline;
   opacity: 01;
   cursor: pointer;
   margin-left: 0px;
   margin-right: auto;
   left: 0px;
   right: 0px;
   outline-color: #5a80bf;
   align-content: center;
   animation: glow 1800ms ease-out infinite alternate;
   border-color: #5a80bf;
   box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
     inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
   outline: none;
   }
   @keyframes glow {
     0% {
       border-color: #11ece5;
       box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
         inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
     }
 
     100% {
       border-color: #11ece5;
       box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
         inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
     }
   }
 
 @media only screen and (max-width: 600px) {
   
 .buttonNews {
   text-decoration: none !important;
   border-radius: 40px;
   padding: 20px;
   width: 10px;
   border: outline;
   opacity: 0.9;
   cursor: pointer;
   margin-left: 0px;
   margin-right: auto;
   left: 0px;
   right: 0px;
   align: center;
   outline-color: #5a80bf;
   outline-style: solid;
   animation: glow 1800ms ease-out infinite alternate;
   border-color: #5a80bf;
   box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
     inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
   outline: none;
   }
   @keyframes glow {
     0% {
       border-color: #11ece5;
       box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
         inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
     }
 
     100% {
       border-color: #11ece5;
       box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
         inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
     }
   }
 }
 .mainNews{
     display: flex;
     flex-wrap: wrap;
     gap: 20px;
     flex-basis: 60%;
     margin-left: auto;
     padding-bottom: 60px;
 }
 .to-top{
     position: fixed;
     right: 20px;
     bottom: 20px;
     z-index: 10;
 }
 
 #to-top-image{
     width: 70px;
     height: 70px;
     border-radius: 50%;
     background-color: palegreen;
     background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yNCAxMmMwIDYuNjIzLTUuMzc3IDEyLTEyIDEycy0xMi01LjM3Ny0xMi0xMiA1LjM3Ny0xMiAxMi0xMiAxMiA1LjM3NyAxMiAxMnptLTEgMGMwIDYuMDcxLTQuOTI5IDExLTExIDExcy0xMS00LjkyOS0xMS0xMSA0LjkyOS0xMSAxMS0xMSAxMSA0LjkyOSAxMSAxMXptLTExLjUtNC44MjhsLTMuNzYzIDQuNjA4LS43MzctLjY3OSA1LTYuMTAxIDUgNi4xMTItLjc1My42NjYtMy43NDctNC42MDR2MTEuODI2aC0xdi0xMS44Mjh6Ii8+PC9zdmc+");
     background-repeat: no-repeat;
     background-position: center;
     background-size: 75%;
 }
 
 #to-top-image:hover{
     cursor: pointer;
     background-color: rgb(133, 223, 133);
 }
 
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top: 5px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Backdrop Animation */
.loading-backdrop {
  position: absolute;
  width: 300%;
  height: 300%;
  background: radial-gradient(circle, #007bff, #001f3f);
  animation: pulse 5s infinite alternate;
  opacity: 0.5;
  z-index: 0;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.4;
  }
  100% {
    transform: scale(1.5);
    opacity: 0.8;
  }
}

/* Loading Spinner */
.loading-container {
  z-index: 1;
  text-align: center;
}

.spinner {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 4px solid transparent;
  border-top: 4px solid #4caf50;
  position: relative;
  animation: spin 1s linear infinite;
}

.spinner-inner {
  position: absolute;
  width: 60px;
  height: 60px;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  border: 4px solid transparent;
  border-top: 4px solid #ffc107;
  animation: spinReverse 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinReverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.step-section {
  margin-top: -70px;

  display: flex;
  padding: 80px;

  height: 100%;
  color: #fff;
}

/* Notification Popup */
.popup-card {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: #444;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  animation: fadeInOut 5s forwards;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}


/* Loading Indicator */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1000;
  animation: fadeInOut 5s forwards;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top: 5px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-container h3 {
  margin-top: 20px;
  color: #fff;
  font-size: 1.2em;
  font-weight: 500;
  letter-spacing: 1px;
}

.error-popup {
  background: #ff4d4d;
}

.notification-popup {
  background: #4caf50;
}

/* Transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

 </style>
 